import { atom } from 'jotai';
import { QueryResultsTableData } from './QueryResultsTableData';

// Context Menu State
interface ContextMenuState {
  isOpen: boolean;
  position: { x: number; y: number } | null;
  rowData: QueryResultsTableData | null;
  columnId: string;
  value: object | string | number | boolean | null | undefined;
}

export const contextMenuStateAtom = atom<ContextMenuState>({
  isOpen: false,
  position: null,
  rowData: null,
  columnId: '',
  value: null,
});

export const closeContextMenuAtom = atom(null, (_get, set) => {
  set(contextMenuStateAtom, {
    isOpen: false,
    position: null,
    rowData: null,
    columnId: '',
    value: null,
  });
});
